<template>
<svg data-svg-lvl-3="spread-block-spread" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514 430"><defs><clipPath id="ls-cp"><path class="ls-c-1" d="M434.6,86.62H78.89a12,12,0,0,0-12,12V340.72a12,12,0,0,0,12,12H434.6a12,12,0,0,0,12-12V98.63A12,12,0,0,0,434.6,86.62Z"/></clipPath></defs><g id="Разворот"><g class="ls-c-4"> <path :style="{ fill: params.slice.color }"  class="ls-c-1" d="M434.6,86.62H78.89a12,12,0,0,0-12,12V340.72a12,12,0,0,0,12,12H434.6a12,12,0,0,0,12-12V98.63A12,12,0,0,0,434.6,86.62Z"/> <image width="1200" height="847" transform="translate(65.52 84.71) scale(0.32)" :href="params.blockImage"  v-show="params.blockImage" preserveAspectRatio="xMidYMid slice" /></g></g></svg></template>


<script>
/** Этот компонент генерируется автоматически, руками ничего менять нельзя!!! */
  
export default {props: { params: { type: Object, required: true, }, }, data() { return {} },}
</script>

<style scoped>.ls-c-1{fill:none;}.ls-c-2{opacity:0.3;}.ls-c-3{fill:#64ff00;}.ls-c-4{clip-path:url(#ls-cp);}</style>

